export const NAMESPACE = 'INSTAGRAM/';

export const SET_SEARCH_TYPE = NAMESPACE + 'SET_SEARCH_TYPE';
export const SET_SOURCE_GROUPS = NAMESPACE + 'SET_SOURCE_GROUPS';
export const SET_SOURCE_USERS = NAMESPACE + 'SET_SOURCE_USERS';
export const SET_SITE_TYPE = NAMESPACE + 'SET_SITE_TYPE';

export const SET_SKIPPED = NAMESPACE + 'SET_SKIPPED';
export const SET_SUBPROGRESS = NAMESPACE + 'SET_SUBPROGRESS';
